import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { addResume, getJPResumeById, udpateResume } from "./ManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import dayjs from "dayjs";
import LoadingSpinner from "../../../component/resuable/LoadingSpinner";
import JapaneseResumeForm from "../resume/JapaneseResumeForm";
import MultiFieldModal from "../resume/MultiFieldModal";
import {
  getJapaneseApplicationById,
  udpateApplication,
} from "../resume/kerala/keralaAdmissionSLice";
import { useLocation } from "react-router-dom";

export default function ManagementEditForm({
  handleBack,
  editData: engliahEditData,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const isDirect = location.pathname.includes("/direct");

  const [newChip, setNewChip] = useState("");
  const [activeTab, setActiveTab] = useState("EN");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [initialModalData, setInitialModalData] = useState();
  const japaneseApplication = useSelector(
    (state) => state.keralaAdmission.japaneseApplication,
  );
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setActiveModal("");
    setInitialModalData([]);
  };
  const appendFileField = (formData, fieldName, value) => {
    if (value instanceof Blob || value instanceof File) {
      formData.append(fieldName, value);
    } else {
      formData.append(fieldName, "");
    }
  };
  const handleTabClick = (value) => {
    if (!editData?.id) {
      setActiveTab(value);
      return;
    }
    if (value == "JP") {
      setIsLoading(true);
      const getFn =
        editData?.location === "kerala"
          ? getJapaneseApplicationById
          : getJPResumeById;
      dispatch(getFn(editData.id))
        .then((response) => {
          if (response.type.includes("fulfilled")) {
            setActiveTab(value);
          }
        })
        .finally(() => setIsLoading(false));
      return;
    }
    setActiveTab(value);
  };
  const jpResumeData = useSelector((state) => state.management.jpResumeData);
  const editData =
    activeTab === "EN"
      ? engliahEditData
      : engliahEditData?.location == "kerala"
        ? japaneseApplication?.candidates?.[0]
        : jpResumeData?.candidates?.[0];
  //   const [initialValues, setInitialValues] = useState({
  //     name: "",
  //     email: "",
  //     phone: "",
  //     skill: [],
  //     // current_salary: '',
  //     // expected_salary: '',
  //     // status: '',
  //     sex: "",
  //     notice_period: "",
  //     // location: '',
  //     // mode: '',
  //     file: "",
  //     id: "",
  //     years_of_exp: "",
  //     language: "",
  //     passport_copy: "",
  //     resident_copy: "",
  //     air_ticket: "",
  //     coe: "",
  //     visa: "",
  //     option_file: "",
  //     remarks: "",
  //     employement_contract: "",
  //     emergency_contact: "",
  //     // contact_details :'',
  //     employeer_name: "",
  //     arrival_date: null,
  //     //  arrival_date : new Date(),

  //     //new fields
  //     admission_number: "",
  //     ad_fees: "",
  //     date_of_admission: new Date(),
  //     dob: null,
  //     passport_no: "",
  //     height: "",
  //     weight: "",
  //     marital_status: "",
  //     nationality: "",
  //     religion: "",
  //     communication: "",
  //     reference: "",
  //     educational_qualification: "",
  //     additional_qualification: "",
  //     english_knowledge: "",
  //     profile_pic: "",
  //     sign: "",
  //     educationalCertificate: "",
  //     medicalReport: "",
  //     vaccinationCertificate: "",

  //     foods_cannot_eat: [],
  //     hobbies: [],
  //     strengths: [],
  //     weaknesses: [],
  //     // Basic Information
  //     employeer_name: "",
  //     name: "",
  //     sex: "",
  //     dob: null,
  //     age: "",
  //     place_of_birth: "",
  //     religion: "",
  //     height: "",
  //     weight: "",
  //     communication: "",

  //     // Personal Details
  //     reason_for_apply: "",
  //     cooperative_living: "",
  //     favorite_subject: "",
  //     licenses_and_qualifications: "",
  //     tattoo: "",
  //     blood_type: "",
  //     right_vision: "",
  //     left_vision: "",
  //     color_blindness: "",
  //     blood_pressure: "",
  //     dominant_hand: "",
  //     foods_cannot_eat: [],
  //     smoking: "",
  //     drinking_beer: "",
  //     hobbies: [],
  //     strengths: [],
  //     weaknesses: [],
  //     medical_history: "",
  //     spouse: "",
  //     language: "",
  //     personal_income: "",
  //     family_income: "",
  //     relatives_in_japan: "",
  //     japanese_address: "",
  //     experience_coming_to_japan: "",
  //     desired_years_to_work_in_japan: "",
  //     savings_per_year: "",
  //     plans_or_goals_after_returning: "",

  //     // Arrays for multi-field sections
  //     academic_details: [],
  //     family_details: [],
  //     work_experience_list: [],

  //     // File fields
  //     japanese_pdf: null,
  //   });
  const [initialValues, setInitialValues] = useState({
    // Basic Information
    id: "",
    name: "",
    email: "",
    phone: "",
    employeer_name: "",
    sex: "",
    age: "",
    dob: null,
    place_of_birth: "",
    religion: "",
    height: "",
    weight: "",
    communication: "",
    nationality: "",
    passport_no: "",
    marital_status: "",

    // Skills & Language
    skill: [],
    language: "",
    english_knowledge: "",
    years_of_exp: "",

    // Personal Details
    reason_for_apply: "",
    cooperative_living: "",
    favorite_subject: "",
    licenses_and_qualifications: "",
    tattoo: "",
    blood_type: "",
    right_vision: "",
    left_vision: "",
    color_blindness: "",
    blood_pressure: "",
    dominant_hand: "",
    foods_cannot_eat: [],
    smoking: "",
    drinking_beer: "",
    hobbies: [],
    strengths: [],
    weaknesses: [],
    medical_history: "",
    spouse: "",

    // Financial Information
    personal_income: "",
    family_income: "",
    savings_per_year: "",

    // Japan-related Information
    relatives_in_japan: "",
    japanese_address: "",
    experience_coming_to_japan: "",
    desired_years_to_work_in_japan: "",
    plans_or_goals_after_returning: "",

    // Work/Status Information
    status: "",
    notice_period: "",
    arrival_date: null,

    // Education/Admission
    admission_number: "",
    ad_fees: "",
    date_of_admission: null,
    educational_qualification: "",
    additional_qualification: "",
    reference: "",

    // Arrays for multi-field sections
    academic_details: [],
    family_details: [],
    work_experience_list: [],

    // File fields
    file: null,
    japanese_pdf: null,
    passport_copy: null,
    resident_copy: null,
    air_ticket: null,
    coe: null,
    visa: null,
    option_file: null,
    employement_contract: null,
    profile_pic: null,
    sign: null,
    educationalCertificate: null,
    medicalReport: null,
    vaccinationCertificate: null,
    japanese_language: "",
    place_of_birth: "",

    // Contact Information
    emergency_contact: "",
    // contact_details: "",

    // Other
    remarks: "",
  });
  const fileValidationSchema = (
    name,
    {
      required = false,
      allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
        "image/webp",
      ],
      maxSize = 5,
    } = {},
  ) => {
    let schema = Yup.mixed()
      .test("fileTypeOrUrl", "Invalid file type or URL string", (value) => {
        if (!value) return true;
        if (typeof value === "string") return true;
        return allowedTypes.includes(value.type);
      })
      .test("fileSize", `File too large (max ${maxSize}MB)`, (value) => {
        if (!value || typeof value === "string") return true;
        return value.size <= maxSize * 1024 * 1024;
      });

    if (required) {
      schema = schema.required("This file is required");
    }

    return { [name]: schema };
  };
  const acedemicFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "start_year",
      fieldLabel: "Start Year",
      type: "date",
      placeholder: "Select start date",
    },
    {
      fieldName: "end_year",
      fieldLabel: "End Year",
      type: "date",
      placeholder: "Select end date",
    },
    {
      fieldName: "school_name",
      fieldLabel: "School Name",
      type: "text",
      placeholder: "Enter school name",
    },
    {
      fieldName: "license",
      fieldLabel: "License",
      type: "text",
      placeholder: "Enter license (e.g., BE)",
    },
    {
      fieldName: "expert",
      fieldLabel: "Expert",
      type: "text",
      placeholder: "Enter expert area",
    },
  ];

  const familyFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "name",
      fieldLabel: "Name",
      type: "text",
      placeholder: "Enter name",
    },
    {
      fieldName: "relationship",
      fieldLabel: "Relationship",
      type: "text",
      placeholder: "Enter relationship",
    },
    {
      fieldName: "age",
      fieldLabel: "Age",
      type: "number",
      placeholder: "Enter age",
    },
    {
      fieldName: "occupation",
      fieldLabel: "Occupation",
      type: "text",
      placeholder: "Enter occupation",
    },
  ];

  const workExperienceFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "start_year",
      fieldLabel: "Start Year",
      type: "date",
      placeholder: "Select start date",
    },
    {
      fieldName: "end_year",
      fieldLabel: "End Year",
      type: "date",
      placeholder: "Select end date",
    },
    {
      fieldName: "job_description",
      fieldLabel: "Job Description",
      type: "text",
      placeholder: "Enter job description",
    },
    {
      fieldName: "equipment_used",
      fieldLabel: "Equipment Used",
      type: "text",
      placeholder: "Enter equipment used",
    },
    {
      fieldName: "company_name",
      fieldLabel: "Company Name",
      type: "text",
      placeholder: "Enter company name",
    },
  ];
  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("User Name is required"),
    // email: Yup.string().required("Email is required"),
    phone: Yup.string().required("Phone Number is required"),
    // skill: Yup.array().min(1, "At least one Skill is required"),
    // current_salary: Yup.string().required("Current Salary is required"),
    // expected_salary: Yup.string().required("Expected Salary is required"),
    // status: Yup.string().required("Status is required"),
    // sex: Yup.string().required("Sex is required"),
    // location: Yup.string().required("Location is required"),
    // file: Yup.string().required("File is required"),
    // mode: Yup.string().required("Preferred is required"),
    // years_of_exp: Yup.string().required("Experience is required"),
    // language: Yup.string().required("language is required"),
    emergency_contact: Yup.string().required("Emergency is required"),
    // contact_details: Yup.string().required("Contact Details is required"),
    arrival_date: Yup.string().required("Arrival Date is required"),
    employeer_name: Yup.string().required("Company Name is required"),
    // ...fileValidationSchema('option_file', {
    // required: true,
    // maxSize: 10,
    // }),
    ...fileValidationSchema("visa", {
      required: true,
      maxSize: 10,
    }),
    ...fileValidationSchema("coe", {
      required: true,
      maxSize: 10,
    }),
    ...fileValidationSchema("air_ticket", {
      required: true,
      maxSize: 10,
    }),
    ...fileValidationSchema("resident_copy", {
      required: true,
      maxSize: 10,
    }),
    ...fileValidationSchema("passport_copy", {
      required: true,
      maxSize: 10,
    }),
    ...fileValidationSchema("employement_contract", {
      required: true,
      maxSize: 10,
    }),
  });
  const validationSchemaJp = Yup.object().shape({
    name: Yup.string().required("ユーザー名は必須です"),
    sex: Yup.string().required("性別は必須です"),
    language: Yup.string().required("言語は必須です"),
    employeer_name: Yup.string().required("雇用者名は必須です"),
    japanese_language: Yup.string().required("日本語の言語は必須です"),
    phone: Yup.string().required("電話番号は必須です"),
  });

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  let role = Cookies.get("role");
  // const isDirect = location.pathname.includes("/director");
  function appendMissingToFormData(formData, obj) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      // Skip if already in FormData
      if (formData.has(key)) continue;

      // Special case: if value is a string with "http" or "https", replace with empty string
      const value =
        typeof obj[key] === "string" && obj[key].startsWith("http")
          ? ""
          : obj[key];

      formData.append(key, value);
    }
    return formData;
  }

  const handleSubmit = async (values) => {
    console.log("I'm clicked");
    const appendArrayField = (formData, fieldName, fieldValues) => {
      if (Array.isArray(fieldValues) && fieldValues.length > 0) {
        formData.append(
          fieldName,
          fieldValues.length === 1 ? fieldValues[0] : fieldValues.join(","),
        );
      }
    };

    const formattedArrivalDate = values.arrival_date
      ? formatDate(values.arrival_date)
      : "";
    const formattedDob = values.dob
      ? dayjs(values.dob).format("YYYY-MM-DD")
      : "";
    const formattedDate_of_admission = values.date_of_admission
      ? dayjs(values.date_of_admission).format("YYYY-MM-DD")
      : "";
    setIsLoading(true);
    let formData = new FormData();
    // console.log(values.mode)
    // formData.append("mode", values.mode)
    //  if (values.arrival_date) {
    //     const selectedDate = new Date(values.arrival_date);
    //     selectedDate.setMinutes(selectedDate.getMinutes() - selectedDate.getTimezoneOffset());
    //     formData.append('arrival_date', selectedDate.toISOString().split('T')[0]);
    // }

    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("phone", values.phone);
    formData.append("japanese_language", values.japanese_language);
    formData.append("place_of_birth", values.place_of_birth);
    formData.append("cooperative_living", values.cooperative_living);
    formData.append("favorite_subject", values.favorite_subject);
    formData.append("reason_for_apply", values.reason_for_apply);
    formData.append(
      "licenses_and_qualifications",
      values.licenses_and_qualifications,
    );
    formData.append("color_blindness", values.color_blindness);
    appendArrayField(formData, "foods_cannot_eat", values.foods_cannot_eat);
    // formData.append("foods_cannot_eat", values.foods_cannot_eat.join(","));
    formData.append("blood_pressure", values.blood_pressure);
    formData.append("medical_history", values.medical_history);
    formData.append("japanese_address", values.japanese_address);
    formData.append(
      "plans_or_goals_after_returning",
      values.plans_or_goals_after_returning,
    );
    formData.append(
      "academic_details",
      JSON.stringify(values.academic_details),
    );
    formData.append("family_details", JSON.stringify(values.family_details));
    formData.append(
      "work_experience_list",
      JSON.stringify(values.work_experience_list),
    );
    appendArrayField(formData, "skill", values.skill);
    appendArrayField(formData, "hobbies", values.hobbies);
    appendArrayField(formData, "strengths", values.strengths);
    appendArrayField(formData, "weaknesses", values.weaknesses);

    // formData.append("skill", values.skill.join(","));
    // formData.append("hobbies", values.hobbies.join(","));
    // formData.append("strengths", values.strengths.join(","));
    // formData.append("weaknesses", values.weaknesses.join(","));
    // formData.append('current_salary', values.current_salary);
    // formData.append('expected_salary', values.expected_salary);
    // formData.append('status', values.status);
    formData.append("notice_period", values.notice_period);
    formData.append("sex", values.sex);
    // formData.append('location', values.location);
    // formData.append('mode', values.mode);
    formData.append("years_of_exp", values.years_of_exp);
    formData.append("language", values.language);
    formData.append("remarks", values.remarks);
    formData.append("emergency_contact", values.emergency_contact);
    // formData.append('contact_details', values.contact_details);
    formData.append("employeer_name", values.employeer_name);
    formData.append("arrival_date", formattedArrivalDate);

    //new fields
    formData.append("admission_number", values.admission_number);
    formData.append("ad_fees", values.ad_fees);
    formData.append("date_of_admission", formattedDate_of_admission);
    formData.append("dob", formattedDob);
    formData.append("passport_no", values.passport_no);
    formData.append("height", values.height);
    formData.append("weight", values.weight);
    formData.append("marital_status", values.marital_status);
    formData.append("nationality", values.nationality);
    formData.append("religion", values.religion);
    formData.append("communication", values.communication);
    formData.append("reference", values.reference);
    formData.append(
      "educational_qualification",
      values.educational_qualification,
    );
    formData.append(
      "additional_qualification",
      values.additional_qualification,
    );
    formData.append("english_knowledge", values.english_knowledge);
    formData.append("version", activeTab === "EN" ? "EN" : "JP");
    formData.append("location", isDirect ? "Direct" : "chennai");
    if (editData) {
      formData.append("id", values.id);
      formData.append(
        "japanese_file",
        typeof values.japanese_file === "string" &&
          values.japanese_file.includes("http")
          ? ""
          : values.japanese_file,
      );
      appendFileField(
        formData,
        "educationalCertificate",
        typeof values.educationalCertificate === "string" &&
          values.educationalCertificate.includes("http")
          ? ""
          : values.educationalCertificate,
      );
      appendFileField(
        formData,
        "vaccinationCertificate",
        typeof values.vaccinationCertificate === "string" &&
          values.vaccinationCertificate.includes("http")
          ? ""
          : values.vaccinationCertificate,
      );
      appendFileField(
        formData,
        "profile_pic",
        typeof values.profile_pic === "string" &&
          values.profile_pic.includes("http")
          ? ""
          : values.profile_pic,
      );
      appendFileField(
        formData,
        "sign",
        typeof values.sign === "string" && values.sign.includes("http")
          ? ""
          : values.sign,
      );
      appendFileField(
        formData,
        "file",
        typeof values.file === "string" && values.file.includes("http")
          ? ""
          : values.file,
      );
      appendFileField(
        formData,
        "passport_copy",
        typeof values.passport_copy === "string" &&
          values.passport_copy.includes("http")
          ? ""
          : values.passport_copy,
      );
      appendFileField(
        formData,
        "resident_copy",
        typeof values.resident_copy === "string" &&
          values.resident_copy.includes("http")
          ? ""
          : values.resident_copy,
      );
      appendFileField(
        formData,
        "air_ticket",
        typeof values.air_ticket === "string" &&
          values.air_ticket.includes("http")
          ? ""
          : values.air_ticket,
      );
      appendFileField(
        formData,
        "coe",
        typeof values.coe === "string" && values.coe.includes("http")
          ? ""
          : values.coe,
      );
      appendFileField(
        formData,
        "option_file",
        typeof values.option_file === "string" &&
          values.option_file.includes("http")
          ? ""
          : values.option_file,
      );
      appendFileField(
        formData,
        "visa",
        typeof values.visa === "string" && values.visa.includes("http")
          ? ""
          : values.visa,
      );
      appendFileField(
        formData,
        "medicalReport",
        typeof values.medicalReport === "string" &&
          values.medicalReport.includes("http")
          ? ""
          : values.medicalReport,
      );
      appendFileField(
        formData,
        "employement_contract",
        typeof values.employement_contract === "string" &&
          values.employement_contract.includes("http")
          ? ""
          : values.employement_contract,
      );
      appendMissingToFormData(formData, values);
      const updateFn =
        editData?.location !== "kerala" ? udpateResume : udpateApplication;
      const response = await dispatch(
        updateFn({ id: editData.id, formData }),
      ).unwrap();

      if (response.status === 200) {
        handleBack();
        toast.success("Candidate Resume Updated Successfully");
      } else {
        toast.error(response.data.message || "Failed to update resume");
      }
    } else {
      const response = await dispatch(addResume(formData));
      if (response.payload.status === 201) {
        handleBack();
        toast.success("User data added Successfully");
      } else {
        toast.error(response.payload.data.message);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (editData) {
      setInitialValues({
        // ...editData,
        ...Object.fromEntries(
          Object.entries(editData ?? {})?.map(([key, value]) => [
            key,
            value === null ? "" : value,
          ]),
        ),
        id: editData.id || "",
        name: editData.name || "",
        email: editData.email || "",
        phone: editData.phone || "",
        skill: editData.skill ? editData.skill.split(",") : [],
        // current_salary: editData.current_salary || '',
        // expected_salary: editData.expected_salary || '',
        // status: editData.status || '',
        sex: editData.sex || "",
        notice_period: editData.notice_period || "",
        // location: editData.location || '',
        // mode: editData.mode || '',
        file: editData.file_download || "",
        years_of_exp: editData.years_of_exp || "",
        language: editData.language || "",
        japanese_file: editData.japanese_file_path || "",
        passport_copy: editData.passport_copy || "",
        resident_copy: editData.resident_copy || "",
        air_ticket: editData.air_ticket || "",
        coe: editData.coe || "",
        visa: editData.visa || "",
        option_file: editData.option_file || "",
        remarks: editData.remarks || "",
        employement_contract: editData.employement_contract || "",
        emergency_contact: editData.emergency_contact || "",
        // contact_details:editData.contact_details || '',
        employeer_name: editData.employeer_name || "",
        arrival_date: editData.arrival_date
          ? new Date(editData.arrival_date)
          : "",

        //new fields
        admission_number: editData.admission_number || "",
        ad_fees: editData.ad_fees || "",
        date_of_admission: editData.date_of_admission || "",
        dob: editData.dob ? new Date(editData.dob) : "",
        passport_no: editData.passport_no || "",
        height: editData.height || "",
        weight: editData.weight || "",
        marital_status: editData.marital_status || "",
        nationality: editData.nationality || "",
        religion: editData.religion || "",
        communication: editData.communication || "",
        reference: editData.reference || "",
        educational_qualification: editData.educational_qualification || "",
        additional_qualification: editData.additional_qualification || "",
        english_knowledge: editData.english_knowledge || "",
        profile_pic: editData.profile_pic || "",
        sign: editData.sign || "",
        educationalCertificate: editData.educationalCertificate || "",
        medifoods_cannot_eat:
          typeof editData.foods_cannot_eat === "string"
            ? editData.foods_cannot_eat
                .split(",")
                .map((h) => h.trim())
                .filter(Boolean)
            : Array.isArray(editData.foods_cannot_eat)
              ? editData.foods_cannot_eat
                  .map((h) => String(h).trim())
                  .filter(Boolean)
              : [],
        calReport: editData.medicalReport || "",
        vaccinationCertificate: editData.vaccinationCertificate || "",
        foods_cannot_eat: editData.foods_cannot_eat
          ? editData.foods_cannot_eat.split(",")
          : [],
        hobbies:
          typeof editData.hobbies === "string"
            ? editData.hobbies
                .split(",")
                .map((h) => h.trim())
                .filter(Boolean)
            : Array.isArray(editData.hobbies)
              ? editData.hobbies.map((h) => String(h).trim()).filter(Boolean)
              : [],
        strengths:
          typeof editData.strengths === "string"
            ? editData.strengths
                .split(",")
                .map((h) => h.trim())
                .filter(Boolean)
            : Array.isArray(editData.strengths)
              ? editData.strengths.map((h) => String(h).trim()).filter(Boolean)
              : [],
        weaknesses:
          typeof editData.weaknesses === "string"
            ? editData.weaknesses
                .split(",")
                .map((h) => h.trim())
                .filter(Boolean)
            : Array.isArray(editData.weaknesses)
              ? editData.weaknesses.map((h) => String(h).trim()).filter(Boolean)
              : [],
        place_of_birth: editData.place_of_birth || "",
        age: editData.age || "",
        reason_for_apply: editData.reason_for_apply || "",
        cooperative_living: editData.cooperative_living || "",
        favorite_subject: editData.favorite_subject || "",
        licenses_and_qualifications: editData.licenses_and_qualifications || "",
        tattoo: editData.tattoo || "",
        blood_type: editData.blood_type || "",
        right_vision: editData.right_vision || "",
        left_vision: editData.left_vision || "",
        color_blindness: editData.color_blindness || "",
        blood_pressure: editData.blood_pressure || "",
        dominant_hand: editData.dominant_hand || "",
        smoking: editData.smoking || "",
        drinking_beer: editData.drinking_beer || "",
        medical_history: editData.medical_history || "",
        spouse: editData.spouse || "",
        personal_income: editData.personal_income || "",
        family_income: editData.family_income || "",
        savings_per_year: editData.savings_per_year || "",
        relatives_in_japan: editData.relatives_in_japan || "",
        japanese_address: editData.japanese_address || "",
        experience_coming_to_japan: editData.experience_coming_to_japan || "",
        desired_years_to_work_in_japan:
          editData.desired_years_to_work_in_japan || "",
        plans_or_goals_after_returning:
          editData.plans_or_goals_after_returning || "",
        academic_details: editData.academic_details || [],
        family_details: editData.family_details || [],
        work_experience_list: editData.work_experience_list || [],
        medicalReport: editData.medicalReport || "",
      });
    }
  }, [editData]);

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <div className="col-md-12">
        <div className="card p-3">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link custom-link ${activeTab === "EN" ? "active" : ""}`}
                id="pills-english-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-english"
                type="button"
                role="tab"
                aria-controls="pills-english"
                aria-selected="true"
                onClick={() => handleTabClick("EN")}
              >
                English
              </button>
            </li>
            {role == "hr" || role === "managerment" ? null : (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link custom-link  ${activeTab === "JP" ? "active" : ""}`}
                  id="pills-japanese-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-japanese"
                  type="button"
                  role="tab"
                  aria-controls="pills-japanese"
                  aria-selected="false"
                  onClick={() => handleTabClick("JP")}
                >
                  Japanese
                </button>
              </li>
            )}
          </ul>
          {activeTab === "JP" && (
            <JapaneseResumeForm
              initialValues={initialValues}
              validationSchema={validationSchemaJp}
              handleSubmit={handleSubmit}
              role={role}
              handleBack={handleBack}
            />
          )}
          {activeTab === "EN" && (
            <Formik
              hidden
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values, setFieldValue }) => {
                const handleAddChip = (fieldName) => {
                  const inputValue = newChip[fieldName];
                  if (inputValue && !values[fieldName].includes(inputValue)) {
                    const updatedValues = [...values[fieldName], inputValue];
                    setFieldValue(fieldName, updatedValues);

                    setNewChip((prev) => ({ ...prev, [fieldName]: "" })); // Clear only the relevant field
                  }
                };

                // const handleRemoveChip = (fieldName, chipToRemove) => {
                //     const updatedValues = values[fieldName].filter(chip => chip !== chipToRemove);
                //     setFieldValue(fieldName, updatedValues);
                // };
                const handleRemoveChip = (chipToRemove, fieldName) => {
                  const updatedValues = values[fieldName].filter(
                    (chip) => chip !== chipToRemove,
                  );
                  setFieldValue(fieldName, updatedValues);
                };
                const handleKeyDown = (e, fieldName) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddChip(fieldName);
                  }
                };
                // console.log("values", values);
                return (
                  <Form>
                    <div className="row">
                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">
                            Emergency Contact{" "}
                          </label>
                          <Field
                            type="number"
                            min={0}
                            className="form-control"
                            placeholder="Enter Emergency Contact Number"
                            name="emergency_contact"
                            // disabled={role === 'intermediate'}
                          />
                          <ErrorMessage
                            name="emergency_contact"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Visa </label>
                          <input
                            type="file"
                            className="form-control"
                            name="visa"
                            onChange={(event) => {
                              setFieldValue("visa", event.target.files[0]); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="visa"
                            component="div"
                            className="text-danger"
                          />

                          {values.visa && typeof values.visa === "string" && (
                            <a
                              href={values.visa}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">COE </label>
                          <input
                            type="file"
                            className="form-control"
                            name="coe"
                            onChange={(event) => {
                              setFieldValue("coe", event.target.files[0]); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="coe"
                            component="div"
                            className="text-danger"
                          />

                          {values.coe && typeof values.coe === "string" && (
                            <a
                              href={values.coe}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Air Ticket </label>
                          <input
                            type="file"
                            className="form-control"
                            name="air_ticket"
                            onChange={(event) => {
                              setFieldValue(
                                "air_ticket",
                                event.target.files[0],
                              ); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="air_ticket"
                            component="div"
                            className="text-danger"
                          />

                          {values.air_ticket &&
                            typeof values.air_ticket === "string" && (
                              <a
                                href={values.air_ticket}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mt-2"
                              >
                                Download Current File
                              </a>
                            )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">
                            Employement Contract{" "}
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            name="employement_contract"
                            onChange={(event) => {
                              setFieldValue(
                                "employement_contract",
                                event.target.files[0],
                              ); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="employement_contract"
                            component="div"
                            className="text-danger"
                          />

                          {values.employement_contract &&
                            typeof values.employement_contract === "string" && (
                              <a
                                href={values.employement_contract}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mt-2"
                              >
                                Download Current File
                              </a>
                            )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Resident File</label>
                          <input
                            type="file"
                            className="form-control"
                            name="resident_copy  "
                            onChange={(event) => {
                              setFieldValue(
                                "resident_copy",
                                event.target.files[0],
                              ); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="resident_copy"
                            component="div"
                            className="text-danger"
                          />

                          {values.resident_copy &&
                            typeof values.resident_copy === "string" && (
                              <a
                                href={values.resident_copy}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mt-2"
                              >
                                Download Current File
                              </a>
                            )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Passport</label>
                          <input
                            type="file"
                            className="form-control"
                            name="passport_copy "
                            onChange={(event) => {
                              setFieldValue(
                                "passport_copy",
                                event.target.files[0],
                              ); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="passport_copy"
                            component="div"
                            className="text-danger"
                          />

                          {values.passport_copy &&
                            typeof values.passport_copy === "string" && (
                              <a
                                href={values.passport_copy}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mt-2"
                              >
                                Download Current File
                              </a>
                            )}
                        </div>
                      )}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Contact Details  </label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter Contact Details  '
                                            name='contact_details'
                                        />
                                        <ErrorMessage name='contact_details' component='div' className="text-danger" />
                                    </div> */}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Arrival Date </label>
                          <DatePicker
                            className="form-control"
                            placeholderText="Select Your Arrival Date "
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            selected={values.arrival_date}
                            onChange={(date) => {
                              setFieldValue("arrival_date", date);
                            }}
                          />
                          <ErrorMessage
                            name="arrival_date"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Option File </label>
                          <input
                            type="file"
                            className="form-control"
                            name="option_file"
                            onChange={(event) => {
                              setFieldValue(
                                "option_file",
                                event.target.files[0],
                              ); // Set the file to Formik state
                            }}
                            // disabled={role === "hr" ? true: false}
                          />
                          <ErrorMessage
                            name="option_file"
                            component="div"
                            className="text-danger"
                          />

                          {values.option_file &&
                            typeof values.option_file === "string" && (
                              <a
                                href={values.option_file}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mt-2"
                              >
                                Download Current File
                              </a>
                            )}
                        </div>
                      )}

                      {role !== "intermediate" && isDirect && (
                        <div className="col-md-4 px-3 py-2">
                          <label className="form-label">Remarks </label>
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Enter remarks "
                            name="remarks"
                            // disabled={role === 'intermediate'}
                          />
                          <ErrorMessage
                            name="remarks"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      )}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Name</label>
                        <Field
                          type="text"
                          className="form-control pointer-none"
                          placeholder="Enter User Name"
                          name="name"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      {/* 
                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Email</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter User Email'
                                            name='email'
                                            disabled
                                        />
                                        <ErrorMessage name='email' component='div' className="text-danger" />
                                    </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Phone Number</label>
                        <Field
                          type="number"
                          min={0}
                          className="form-control"
                          placeholder="Enter Phone Number"
                          name="phone"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className="form-label">Skills</label>
                                        <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                            <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={newChip}
                                                    onChange={(e) => setNewChip(e.target.value)}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="Add a chip and press Enter"
                                                    disabled 
                                                />
                                                <ErrorMessage name='skill' component='div' className="text-danger" />
                                                {values.skill.map((chip, index) => (
                                                    <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                        {chip}
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-white ml-2"
                                                            aria-label="Close"
                                                            onClick={() => handleRemoveChip(chip)}
                                                            disabled={role === 'intermediate'} 
                                                        ></button>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Current Salary</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter Current Salary'
                                            name='current_salary'
                                            disabled 
                                        />
                                        <ErrorMessage name='current_salary' component='div' className="text-danger" />
                                    </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Expected Salary</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter Expected Salary'
                                            name='expected_salary'
                                            disabled
                                        />
                                        <ErrorMessage name='expected_salary' component='div' className="text-danger" />
                                    </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Status</label>
                                        <Field as="select" className='form-select' name="status"  disabled >
                                            <option value="" selected hidden label="Select User Role" />
                                            <option value="Immediate Joiner">Immediate Joiner</option>
                                            <option value="Notice Period">Notice Period</option>
                                        </Field >
                                        <ErrorMessage name='status' component='div' className="text-danger" />
                                    </div>

                                    {values.status === "Notice Period" && (
                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Notice period</label>
                                            <Field
                                                type='text'
                                                className='form-control'
                                                placeholder='Enter notice period'
                                                name='notice_period'
                                                disabled 
                                            />
                                            <ErrorMessage name='notice_period' component='div' className="text-danger" />

                                        </div>
                                    )} */}
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Company Name </label>
                        <Field
                          type="text"
                          className="form-control"
                          placeholder="Enter Company Name  "
                          name="employeer_name"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="employeer_name"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Sex</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="sex"
                          disabled={role === "management" ? true : false}
                        >
                          <option
                            value=""
                            selected
                            hidden
                            label="Select the Gender"
                          />
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Others">Others</option>
                        </Field>
                        <ErrorMessage
                          name="sex"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Location</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter Location'
                                            name='location'
                                            disabled 
                                        />
                                        <ErrorMessage name='location' component='div' className="text-danger" />

                                    </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Preferred </label>
                                        <Field as="select" className='form-select' name="mode"  disabled >
                                            <option value="" selected hidden label="Select the Preferred" />
                                            <option value="Remote">Remote</option>
                                            <option value="Work From Office">Work From Office</option>
                                        </Field >
                                        <ErrorMessage name='mode' component='div' className="text-danger" />
                                    </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Experience (Year) </label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder='Enter Total Experience'
                                            name='years_of_exp'
                                            disabled 
                                        />
                                        <ErrorMessage name='years_of_exp' component='div' className="text-danger" />

                                    </div> */}
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Age</label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Age"
                          name="age"
                          // disabled={role === "management" ? true : false}
                          disabled
                        />
                        <ErrorMessage
                          name="age"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Birth Place</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Birth Place"
                          name="place_of_birth"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="place_of_birth"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Reason For Apply</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Reason"
                          name="reason_for_apply"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="reason_for_apply"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Co-operative Living
                        </label>
                        <Field
                          className="form-control"
                          placeholder="Enter Co-operative Living"
                          name="cooperative_living"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="cooperative_living"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Favourite Subject</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Favourite Subject"
                          name="favorite_subject"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="favorite_subject"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          License & Qualification
                        </label>
                        <Field
                          className="form-control"
                          placeholder="Enter License and Qualification"
                          name="licenses_and_qualifications"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="licenses_and_qualifications"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Tatto</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="tattoo"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="tattoo"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Blood Type</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Blood Type"
                          name="blood_type"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="blood_type"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Right Vision</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Right Vision"
                          name="right_vision"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="right_vision"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Left Vision</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Left Vision"
                          name="left_vision"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="left_vision"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Color-Blindness</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Color-Blindness"
                          name="color_blindness"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="color_blindness"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Blood Pressure</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Blood Pressure"
                          name="blood_pressure"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="blood_pressure"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Dominant Hand</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Dominant Hand"
                          name="dominant_hand"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage name="dominant_hand" component="div" className="text-danger" />
                      </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Dominant Hand</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="dominant_hand"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Right Hand">Right Hand</option>
                          <option value="Left Hand">Left Hand</option>
                        </Field>
                        <ErrorMessage
                          name="dominant_hand"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Foods Not Eat</label>
                        <div
                          className="chips-input-wrapper"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="chips-container"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {/* <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newChip}
                                                                    onChange={(e) => setNewChip(e.target.value)}
                                                                    onKeyDown={(e) => handleKeyDown(e, "foods_cannot_eat")}
                                                                    placeholder="Add a chip and press Enter"
                                                                    disabled={role === 'intermediate'}
                                                                /> */}
                            <input
                              type="text"
                              className="form-control"
                              value={newChip["foods_cannot_eat"] || ""}
                              onChange={(e) =>
                                setNewChip((prev) => ({
                                  ...prev,
                                  foods_cannot_eat: e.target.value,
                                }))
                              }
                              onKeyDown={(e) =>
                                handleKeyDown(e, "foods_cannot_eat")
                              }
                              placeholder="Add a chip and press Enter"
                              disabled={role === "management" ? true : false}
                            />
                            <ErrorMessage
                              name="foods_cannot_eat"
                              component="div"
                              className="text-danger"
                            />
                            {values.foods_cannot_eat.map((chip, index) => (
                              <div
                                key={index}
                                className="chip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 8px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  borderRadius: "16px",
                                }}
                              >
                                {chip}
                                <button
                                  type="button"
                                  className="btn-close btn-close-white ml-2"
                                  aria-label="Close"
                                  onClick={() =>
                                    handleRemoveChip(chip, "foods_cannot_eat")
                                  }
                                  disabled={
                                    role === "management" ? true : false
                                  }
                                ></button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Smoking Habit</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="smoking"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="smoking"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Drinking Habit</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="drinking_beer"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="drinking_beer"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Hobbies</label>
                        <div
                          className="chips-input-wrapper"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="chips-container"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {/* <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newChip}
                                                                    onChange={(e) => setNewChip(e.target.value)}
                                                                    onKeyDown={(e) => handleKeyDown(e, "hobbies")}
                                                                    placeholder="Add a chip and press Enter"
                                                                    disabled={role === 'intermediate'}
                                                                /> */}
                            <input
                              type="text"
                              className="form-control"
                              value={newChip["hobbies"] || ""}
                              onChange={(e) =>
                                setNewChip((prev) => ({
                                  ...prev,
                                  hobbies: e.target.value,
                                }))
                              }
                              onKeyDown={(e) => handleKeyDown(e, "hobbies")}
                              placeholder="Add a chip and press Enter"
                              disabled={role === "management" ? true : false}
                            />
                            <ErrorMessage
                              name="hobbies"
                              component="div"
                              className="text-danger"
                            />
                            {values.hobbies.map((chip, index) => (
                              <div
                                key={index}
                                className="chip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 8px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  borderRadius: "16px",
                                }}
                              >
                                {chip}
                                <button
                                  type="button"
                                  className="btn-close btn-close-white ml-2"
                                  aria-label="Close"
                                  onClick={() =>
                                    handleRemoveChip(chip, "hobbies")
                                  }
                                  disabled={
                                    role === "management" ? true : false
                                  }
                                ></button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Strengths</label>
                        <div
                          className="chips-input-wrapper"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="chips-container"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {/* <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newChip}
                                                                    onChange={(e) => setNewChip(e.target.value)}
                                                                    onKeyDown={(e) => handleKeyDown(e, "strengths")}
                                                                    placeholder="Add a chip and press Enter"
                                                                    disabled={role === 'intermediate'}
                                                                /> */}
                            <input
                              type="text"
                              className="form-control"
                              value={newChip["strengths"] || ""}
                              onChange={(e) =>
                                setNewChip((prev) => ({
                                  ...prev,
                                  strengths: e.target.value,
                                }))
                              }
                              onKeyDown={(e) => handleKeyDown(e, "strengths")}
                              placeholder="Add a chip and press Enter"
                              disabled={role === "management" ? true : false}
                            />
                            <ErrorMessage
                              name="strengths"
                              component="div"
                              className="text-danger"
                            />
                            {values.strengths.map((chip, index) => (
                              <div
                                key={index}
                                className="chip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 8px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  borderRadius: "16px",
                                }}
                              >
                                {chip}
                                <button
                                  type="button"
                                  className="btn-close btn-close-white ml-2"
                                  aria-label="Close"
                                  onClick={() =>
                                    handleRemoveChip(chip, "strengths")
                                  }
                                  disabled={
                                    role === "management" ? true : false
                                  }
                                ></button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Weaknesses </label>
                        <div
                          className="chips-input-wrapper"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="chips-container"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {/* <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={newChip}
                                                                    onChange={(e) => setNewChip(e.target.value)}
                                                                    onKeyDown={(e) => handleKeyDown(e, "weaknesses")}
                                                                    placeholder="Add a chip and press Enter"
                                                                    disabled={role === 'intermediate'}
                                                                /> */}
                            <input
                              type="text"
                              className="form-control"
                              value={newChip["weaknesses"] || ""}
                              onChange={(e) =>
                                setNewChip((prev) => ({
                                  ...prev,
                                  weaknesses: e.target.value,
                                }))
                              }
                              onKeyDown={(e) => handleKeyDown(e, "weaknesses")}
                              placeholder="Add a chip and press Enter"
                              disabled={role === "management" ? true : false}
                            />
                            <ErrorMessage
                              name="weaknesses"
                              component="div"
                              className="text-danger"
                            />
                            {values.weaknesses.map((chip, index) => (
                              <div
                                key={index}
                                className="chip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 8px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  borderRadius: "16px",
                                }}
                              >
                                {chip}
                                <button
                                  type="button"
                                  className="btn-close btn-close-white ml-2"
                                  aria-label="Close"
                                  onClick={() =>
                                    handleRemoveChip(chip, "weaknesses")
                                  }
                                  disabled={
                                    role === "management" ? true : false
                                  }
                                ></button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Medical History</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Medical History"
                          name="medical_history"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="medical_history"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Spouse</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="spouse"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="spouse"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Personal Income (Yen)
                        </label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Personal Income"
                          name="personal_income"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="personal_income"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Family Income (Yen)
                        </label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Family Income"
                          name="family_income"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="family_income"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Relatives In Japan</label>
                        <Field
                          as="select"
                          className="form-select"
                          name="relatives_in_japan"
                          disabled={role === "management" ? true : false}
                        >
                          <option value="" selected hidden label="Select" />
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </Field>
                        <ErrorMessage
                          name="relatives_in_japan"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Japanese Address</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Address"
                          name="japanese_address"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="japanese_address"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Your Experience Visiting Japan
                        </label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Experience"
                          name="experience_coming_to_japan"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="experience_coming_to_japan"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Desired Years To Work In Japan
                        </label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Years"
                          name="desired_years_to_work_in_japan"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="desired_years_to_work_in_japan"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Savings Per Year (Yen)
                        </label>
                        <Field
                          className="form-control"
                          type="number"
                          min={0}
                          placeholder="Enter Savings"
                          name="savings_per_year"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="savings_per_year"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Goals After Returning
                        </label>
                        <Field
                          className="form-control"
                          placeholder="Enter Goals"
                          name="plans_or_goals_after_returning"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="plans_or_goals_after_returning"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Japanese language level{" "}
                        </label>
                        <Field
                          as="select"
                          className="form-select"
                          name="language"
                          disabled={role === "management" ? true : false}
                        >
                          <option
                            value=""
                            selected
                            hidden
                            label="Select Japanese language level"
                          />

                          <option value="Beginner">Beginner</option>
                          <option value="N5">N5</option>
                          <option value="N4">N4</option>
                          <option value="N3">N3</option>
                          <option value="N2">N2</option>
                          <option value="N1">N1</option>
                        </Field>
                        <ErrorMessage
                          name="language"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Resume</label>
                        <input
                          type="file"
                          className="form-control"
                          name="file"
                          onChange={(event) => {
                            setFieldValue("file", event.target.files[0]); // Set the file to Formik state
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.file  &&
                          typeof values.file === "string" &&
                          values.file.includes("http") && (
                          <small className="form-text text-muted">
                            Current file: {decodeURIComponent(values.file.split("?")[0].split("/").pop())}
                          </small>
                        )} */}
                        <ErrorMessage
                          name="file"
                          component="div"
                          className="text-danger"
                        />

                        {values.file && typeof values.file === "string" && (
                          <a
                            href={values.file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-block mt-2"
                          >
                            Download Current File
                          </a>
                        )}
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Japanese Resume</label>
                        <input
                          type="file"
                          className="form-control"
                          name="japanese_file"
                          onChange={(event) => {
                            setFieldValue(
                              "japanese_file",
                              event.target.files[0],
                            ); // Set the file to Formik state
                          }}
                          disabled={role === "management" && true}
                        />
                        {/* {values.japanese_file  &&
                          typeof values.japanese_file === "string" &&
                          values.japanese_file.includes("http") && (
                          <small className="form-text text-muted">
                            Current file: {decodeURIComponent(values.japanese_file.split("?")[0].split("/").pop())}
                          </small>
                        )} */}
                        <ErrorMessage
                          name="japanese_file"
                          component="div"
                          className="text-danger"
                        />

                        {values.japanese_file &&
                          typeof values.japanese_file === "string" && (
                            <a
                              href={values.japanese_file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                      </div>
                      {/* 
                                    <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Admission Number</label>
                                            <Field className='form-control' placeholder='Enter Admission Number' name="admission_number"  disabled />
                                            <ErrorMessage name='admission_number' component='div' className="text-danger" />
                                        </div>

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Admission Fee</label>
                                            <Field className='form-control' placeholder='Enter Admission Fee' name="ad_fees"  disabled />
                                            <ErrorMessage name='ad_fees' component='div' className="text-danger" />
                                        </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Date of Admission</label>
                                            <DatePicker className='form-control' placeholderText='Select Your Date of Admission'
                                                peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                                                dateFormat='dd/MM/yyyy'
                                                selected={values.date_of_admission} onChange={(date) => { setFieldValue('date_of_admission', date) }} 
                                                disabled
                                            />
                                            <ErrorMessage name='date_of_admission' component='div' className="text-danger" />
                                        </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">DOB</label>
                        <DatePicker
                          className="form-control"
                          placeholderText="Select Your DOB"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          selected={values.dob}
                          onChange={(date) => {
                            setFieldValue("dob", date);
                            const today = new Date();
                            const age =
                              today.getFullYear() -
                              date.getFullYear() -
                              (new Date(
                                today.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                              ) > today
                                ? 1
                                : 0);
                            if (typeof age === "number" && !isNaN(age)) {
                              setFieldValue("age", age);
                            }
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="dob"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Passport Number</label>
                                            <Field className='form-control' placeholder='Enter Passport Number' name="passport_no"  disabled />
                                            <ErrorMessage name='passport_no' component='div' className="text-danger" />
                                        </div>

                                        <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Nationality</label>
                                            <Field className='form-control' placeholder='Enter Nationality' name="nationality"  disabled/>
                                            <ErrorMessage name='nationality' component='div' className="text-danger" />
                                        </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Religion</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Religion"
                          name="religion"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="religion"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Educational Qualification</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Educational Qualification"
                          name="educational_qualification"
                          disabled
                        />
                        <ErrorMessage name="educational_qualification" component="div" className="text-danger" />
                      </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Additional Qualification</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Additional Qualification"
                          name="additional_qualification"
                          disabled
                        />
                        <ErrorMessage name="additional_qualification" component="div" className="text-danger" />
                      </div> */}

                      {/* <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Marital Status</label>
                                            <Field as="select" className='form-select' name='marital_status'  disabled >
                                                <option value="" selected hidden label="Select an option" />
                                                <option value="Married">Married</option>
                                                <option value="UnMarried">UnMarried</option>
                                            </Field>
                                        </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Height</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Height"
                          name="height"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="height"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Weight</label>
                        <Field
                          className="form-control"
                          placeholder="Enter Weight"
                          name="weight"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="weight"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Communication Address
                        </label>
                        <Field
                          className="form-control"
                          placeholder="Enter Communication Address"
                          name="communication"
                          disabled={role === "management" ? true : false}
                        />
                        <ErrorMessage
                          name="communication"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>Reference</label>
                                            <Field className='form-control' placeholder='Enter Reference' name="reference"  disabled />
                                            <ErrorMessage name='reference' component='div' className="text-danger" />
                                        </div>
  */}
                      {/* <div className="col-md-4 px-3 py-2">
                                            <label className='form-label'>English Knowledge</label>
                                            <Field as="select" className='form-select' name='english_knowledge'  disabled>
                                                <option value="" selected hidden label="Select an option" />
                                                <option value="Good">Good</option>
                                                <option value="Average">Average</option>
                                                <option value="Poor">Poor</option>
                                            </Field>
                                        </div> */}

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Full size photo</label>
                        <input
                          type="file"
                          className="form-control"
                          placeholder="Enter your photo"
                          onChange={(event) => {
                            setFieldValue(
                              "profile_pic",
                              event.currentTarget.files[0],
                            );
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.profile_pic &&
                          typeof values.profile_pic === "string" &&
                          values.profile_pic.includes("http") && (
                            <small className="form-text text-muted">
                              Current file: {decodeURIComponent(values.profile_pic.split("?")[0].split("/").pop())}
                            </small>
                          )} */}
                        {/* {values.profile_pic && (
                                                <div className='mt-2 profileimage'>
                                                    {values.profile_pic.type.includes('image') ? (
                                                        <img
                                                            src={URL.createObjectURL(values.profile_pic)}
                                                            alt="Selected Profile "
                                                        />
                                                    ) : (
                                                        <embed
                                                            src={URL.createObjectURL(values.profile_pic)}

                                                            type="application/pdf"
                                                        />
                                                    )}
                                                </div>
                                            )} */}

                        {values.profile_pic &&
                          typeof values.profile_pic === "string" &&
                          values.profile_pic.includes("http") && (
                            <a
                              href={values.profile_pic}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Signature</label>
                        <input
                          type="file"
                          className="form-control"
                          placeholder="Enter your signature"
                          onChange={(event) => {
                            setFieldValue("sign", event.currentTarget.files[0]);
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.sign  &&
                          typeof values.sign === "string" &&
                          values.sign.includes("http") && (
                          <small className="form-text text-muted">
                            Current file: {decodeURIComponent(values.sign.split("?")[0].split("/").pop())}
                          </small>
                        )} */}

                        {/* {values.sign && (
                                                <div className='mt-2 profileimage'>
                                                    {values.sign.type.includes('image') ? (
                                                        <img
                                                            src={URL.createObjectURL(values.sign)}
                                                            alt="Selected Signature"
                                                        />
                                                    ) : (
                                                        <embed
                                                            src={URL.createObjectURL(values.sign)}

                                                            type="application/pdf"
                                                        />
                                                    )}
                                                </div>
                                            )} */}

                        {values.sign && typeof values.sign === "string" && (
                          <a
                            href={values.sign}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-block mt-2"
                          >
                            Download Current File
                          </a>
                        )}
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Educational Certificate
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          placeholder="Enter your name"
                          onChange={(event) => {
                            setFieldValue(
                              "educationalCertificate",
                              event.currentTarget.files[0],
                            );
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.educationalCertificate  &&
                          typeof values.educationalCertificate === "string" &&
                          values.educationalCertificate.includes("http") && (
                          <small className="form-text text-muted">
                            Current file:{" "}
                            {decodeURIComponent(values.educationalCertificate.split("?")[0].split("/").pop())}
                          </small>
                        )} */}

                        {/* {values.educationalCertificate && (
                                                <div className='mt-2 profileimage'>
                                                    {values.educationalCertificate.type.includes('image') ? (
                                                        <img
                                                            src={URL.createObjectURL(values.educationalCertificate)}
                                                            alt="Selected educationalCertificate"
                                                        />
                                                    ) : (
                                                        <embed
                                                            src={URL.createObjectURL(values.educationalCertificate)}

                                                            type="application/pdf"
                                                        />
                                                    )}
                                                </div>
                                            )} */}

                        {values.educationalCertificate &&
                          typeof values.educationalCertificate === "string" && (
                            <a
                              href={values.educationalCertificate}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Medical Report</label>
                        <input
                          type="file"
                          className="form-control"
                          placeholder="Enter your name"
                          onChange={(event) => {
                            setFieldValue(
                              "medicalReport",
                              event.currentTarget.files[0],
                            );
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.medicalReport  &&
                          typeof values.medicalReport === "string" &&
                          values.medicalReport.includes("http") && (
                          <small className="form-text text-muted">
                            Current file: {decodeURIComponent(values.medicalReport.split("?")[0].split("/").pop())}
                          </small>
                        )} */}

                        {/* {values.medicalReport && (
                                                <div className='mt-2 profileimage'>
                                                    {values.medicalReport.type.includes('image') ? (
                                                        <img
                                                            src={URL.createObjectURL(values.medicalReport)}
                                                            alt="Selected medicalReport"
                                                        />
                                                    ) : (
                                                        <embed
                                                            src={URL.createObjectURL(values.medicalReport)}

                                                            type="application/pdf"
                                                        />
                                                    )}
                                                </div>
                                            )} */}

                        {values.medicalReport &&
                          typeof values.medicalReport === "string" && (
                            <a
                              href={values.medicalReport}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">
                          Vaccination Certificate
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          placeholder="Enter your name"
                          onChange={(event) => {
                            setFieldValue(
                              "vaccinationCertificate",
                              event.currentTarget.files[0],
                            );
                          }}
                          disabled={role === "management" ? true : false}
                        />
                        {/* {values.vaccinationCertificate  &&
                          typeof values.vaccinationCertificate === "string" &&
                          values.vaccinationCertificate.includes("http") && (
                          <small className="form-text text-muted">
                            Current file:{" "}
                            {decodeURIComponent(values.vaccinationCertificate.split("?")[0].split("/").pop())}
                          </small>
                        )} */}
                        {isModalOpen && activeModal === "academic_details" && (
                          <MultiFieldModal
                            disabled={role === "management" ? true : false}
                            handleCloseModal={handleCloseModal}
                            fields={acedemicFields}
                            containerFieldName={"academic_details"}
                            modalTitle={"Add Acedamic Details"}
                            setFieldValue={setFieldValue}
                            initialData={initialModalData}
                          />
                        )}

                        {isModalOpen && activeModal === "family_details" && (
                          <MultiFieldModal
                            disabled={role === "management" ? true : false}
                            handleCloseModal={handleCloseModal}
                            fields={familyFields}
                            containerFieldName={"family_details"}
                            modalTitle={"Add Family Details"}
                            setFieldValue={setFieldValue}
                            initialData={initialModalData}
                          />
                        )}

                        {isModalOpen &&
                          activeModal === "work_experience_list" && (
                            <MultiFieldModal
                              handleCloseModal={handleCloseModal}
                              disabled={role === "management" ? true : false}
                              fields={workExperienceFields}
                              containerFieldName={"work_experience_list"}
                              modalTitle={"Add Work Experience"}
                              setFieldValue={setFieldValue}
                              initialData={initialModalData}
                            />
                          )}

                        {/* {values.vaccinationCertificate && (
                                                <div className='mt-2 profileimage'>
                                                    {values.vaccinationCertificate.type.includes('image') ? (
                                                        <img
                                                            src={URL.createObjectURL(values.vaccinationCertificate)}
                                                            alt="Selected vaccinationCertificate"
                                                        />
                                                    ) : (
                                                        <embed
                                                            src={URL.createObjectURL(values.vaccinationCertificate)}

                                                            type="application/pdf"
                                                        />
                                                    )}
                                                </div>
                                            )} */}

                        {values.vaccinationCertificate &&
                          typeof values.vaccinationCertificate === "string" && (
                            <a
                              href={values.vaccinationCertificate}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="d-block mt-2"
                            >
                              Download Current File
                            </a>
                          )}
                      </div>
                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Acedemic Details</label>
                        <div>
                          {values["academic_details"].length > 0 ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-warning me-2"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setActiveModal("academic_details");
                                  setInitialModalData(
                                    values["academic_details"],
                                  );
                                }}
                              >
                                {/* Update Academic Detail */}
                                {role === "management"
                                  ? "Academic Details List"
                                  : "Update Academic Detail"}
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                setIsModalOpen(true);
                                setActiveModal("academic_details");
                              }}
                            >
                              {/* Add Academic Detail */}
                              {role === "management"
                                ? "Academic Details List"
                                : "Add Academic Detail"}
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Family Details</label>
                        <div>
                          {values["family_details"].length > 0 ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-warning me-2"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setActiveModal("family_details");
                                  setInitialModalData(values["family_details"]);
                                }}
                              >
                                {/* Update Family Detail */}
                                {role === "management"
                                  ? "Family Details List"
                                  : "Update Family Detail"}
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                setIsModalOpen(true);
                                setActiveModal("family_details");
                              }}
                            >
                              {/* Add Family Detail */}
                              {role === "management"
                                ? "Family Details List"
                                : "Add Family Detail"}
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4 px-3 py-2">
                        <label className="form-label">Work Experience</label>
                        <div>
                          {values["work_experience_list"].length > 0 ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-warning me-2"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setActiveModal("work_experience_list");
                                  setInitialModalData(
                                    values["work_experience_list"],
                                  );
                                }}
                              >
                                {/* Update Work Experience */}
                                {role === "management"
                                  ? "Work Experience List"
                                  : "Update Work Experience"}
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={() => {
                                setIsModalOpen(true);
                                setActiveModal("work_experience_list");
                              }}
                            >
                              {/* Add Work Experience */}
                              {role === "management"
                                ? "Work Experience List"
                                : "Add Work Experience"}
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col ">
                          <button
                            className="cancel-button ms-2"
                            onClick={handleBack}
                            type="button"
                          >
                            Cancel
                          </button>
                          <button
                            className="btn defult-button ms-2"
                            type="submit"
                            onClick={() => handleSubmit(values)}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>
    </>
  );
}
